export const GET_WALLET_BALANCE = "GET_WALLET_BALANCE";
export const GET_WALLET_BALANCE_SUCCESS = "GET_WALLET_BALANCE_SUCCESS";
export const GET_WALLET_BALANCE_ERROR = "GET_WALLET_BALANCE_ERROR";

export const GET_WALLET_TRANSACTIONS = "GET_WALLET_TRANSACTIONS";
export const GET_WALLET_TRANSACTIONS_SUCCESS = "GET_WALLET_TRANSACTIONS_SUCCESS";
export const GET_WALLET_TRANSACTIONS_ERROR = "GET_WALLET_TRANSACTIONS_ERROR";

export const CLEAR_TRANSACTIONS = "CLEAR_TRANSACTIONS";

export const CLEAR_WALLET_BALANCE = "CLEAR_WALLET_BALANCE";

export const REQUEST_WITHDRAWAL = "REQUEST_WITHDRAWAL"; 
export const REQUEST_WITHDRAWAL_SUCCESS = "REQUEST_WITHDRAWAL_SUCCESS"; 
export const REQUEST_WITHDRAWAL_ERROR = "REQUEST_WITHDRAWAL_ERROR"; 

export const GET_EACH_WALLET_TRANSACTION = "GET_EACH_WALLET_TRANSACTION";
export const GET_EACH_WALLET_TRANSACTION_SUCCESS = "GET_EACH_WALLET_TRANSACTION_SUCCESS";
export const GET_EACH_WALLET_TRANSACTION_ERROR = "GET_EACH_WALLET_TRANSACTION_ERROR";

export const GET_MY_REFERRALS = "GET_MY_REFERRALS";
export const GET_MY_REFERRALS_SUCCESS = "GET_MY_REFERRALS_SUCCESS";
export const GET_MY_REFERRALS_ERROR = "GET_MY_REFERRALS_ERROR";

export const POST_TRANSFER_TO_PLAN = "POST_TRANSFER_TO_PLAN";
export const POST_TRANSFER_TO_PLAN_SUCCESS = "POST_TRANSFER_TO_PLAN_SUCCESS";
export const POST_TRANSFER_TO_PLAN_ERROR = "POST_TRANSFER_TO_PLAN_ERROR";

export const POKE_USER = "POKE_USER";
export const POKE_USER_SUCCESS = "POKE_USER_SUCCESS";
export const POKE_USER_ERROR = "POKE_USER_ERROR";

export const GET_MY_REFERRAL_ACTIVITIES = "GET_MY_REFERRAL_ACTIVITIES";
export const GET_MY_REFERRAL_ACTIVITIES_SUCCESS = "GET_MY_REFERRAL_ACTIVITIES_SUCCESS";
export const GET_MY_REFERRAL_ACTIVITIES_ERROR = "GET_MY_REFERRAL_ACTIVITIES_ERROR";

export const REDEEM_REFERRAL_BONUS = "REDEEM_REFERRAL_BONUS"
export const REDEEM_REFERRAL_BONUS_SUCCESS = "REDEEM_REFERRAL_BONUS_SUCCESS"
export const REDEEM_REFERRAL_BONUS_ERROR = "REDEEM_REFERRAL_BONUS_ERROR"

export const GET_MY_DEPOSIT_ACTIVITIES = "GET_MY_DEPOSIT_ACTIVITIES"; 
export const GET_MY_DEPOSIT_ACTIVITIES_SUCCESS = "GET_MY_DEPOSIT_ACTIVITIES_SUCCESS"; 
export const GET_MY_DEPOSIT_ACTIVITIES_ERROR = "GET_MY_DEPOSIT_ACTIVITIES_ERROR"; 

export const GET_REFERRAL_REDEEM_THRESHOLD = "GET_REFERRAL_REDEEM_THRESHOLD";
export const GET_REFERRAL_REDEEM_THRESHOLD_SUCCESS = "GET_REFERRAL_REDEEM_THRESHOLD_SUCCESS";
export const GET_REFERRAL_REDEEM_THRESHOLD_ERROR = "GET_REFERRAL_REDEEM_THRESHOLD_ERROR";

export const REDEEEM_SPECIAL_EARNING = "REDEEEM_SPECIAL_EARNING";
export const REDEEEM_SPECIAL_EARNING_SUCCESS = "REDEEEM_SPECIAL_EARNING_SUCCESS";
export const REDEEEM_SPECIAL_EARNING_ERROR = "REDEEEM_SPECIAL_EARNING_ERROR";

export const GET_SPECIAL_EARNING_ACTIVITIES = "GET_SPECIAL_EARNING_ACTIVITIES";
export const GET_SPECIAL_EARNING_ACTIVITIES_SUCCESS = "GET_SPECIAL_EARNING_ACTIVITIES_SUCCESS";
export const GET_SPECIAL_EARNING_ACTIVITIES_ERROR = "GET_SPECIAL_EARNING_ACTIVITIES_ERROR";

export const GET_TOTAL_EARNING = "GET_TOTAL_EARNING";
export const GET_TOTAL_EARNING_SUCCESS = "GET_TOTAL_EARNING_SUCCESS";
export const GET_TOTAL_EARNING_ERROR = "GET_TOTAL_EARNING_ERROR";

export const GET_TOTAL_REDEEMED_EARNING = "GET_TOTAL_REDEEMED_EARNING";
export const GET_TOTAL_REDEEMED_EARNING_SUCCESS = "GET_TOTAL_REDEEMED_EARNING_SUCCESS";
export const GET_TOTAL_REDEEMED_EARNING_ERROR = "GET_TOTAL_REDEEMED_EARNING_ERROR";